// extracted by mini-css-extract-plugin
export default {"buttonsHolder":"styles_buttonsHolder__XRgyC"};